import { useEffect, useState } from 'react';
import useSettings from '../useSettings';
import { KNOWLEDGE_BASE_URL_KEY } from '../../constants/knowledgeBase';

const SUPPORT_PHONE_KEY = 'whatsappSupportPhone';

/**
 * Número de WhatsApp do suporte e link da base de conhecimento da plataforma,
 * para a barra superior. Lidos uma vez quando o layout abre; falha em um não
 * esconde o outro.
 */
const useSupportLinks = () => {
  const { get } = useSettings();
  const [links, setLinks] = useState({ phone: '', knowledgeBaseUrl: '' });

  useEffect(() => {
    let active = true;
    Promise.allSettled([get(SUPPORT_PHONE_KEY), get(KNOWLEDGE_BASE_URL_KEY)]).then(
      ([phone, knowledgeBase]) => {
        if (!active) return;
        setLinks({
          phone: phone.value?.value || '',
          knowledgeBaseUrl: knowledgeBase.value?.value || '',
        });
      }
    );
    return () => {
      active = false;
    };
  }, [get]);

  return links;
};

export default useSupportLinks;
